import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import playoReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["countryCode", "name", "userId", "userIdv2", "email", "mobile", "deviceType", "fName", "lName", "helpTS"]
};

const middleWare = applyMiddleware(thunk);

const persistedReducer = persistReducer(persistConfig, playoReducer);

export let store = createStore(persistedReducer, middleWare);
export let persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/store.js